/* eslint-disable */

'use strict';

(function AjaxCartMentionMe() {
  window.addEventListener("load", function() {
    // Set Data
    const mmData = JSON.parse(document.querySelector('[data-mm-config]').innerHTML);
    const mmId = mmData.mm_id;
    const mmLocale = mmData.mm_locale;
    const mmSituation = 'sidecart';
    const mmImplementation = 'link';

    // Early Exit
    if (!mmId || !mmLocale) return;

    // This will ensure the implementation (link) and situation (sidecart) get
    // cleared before loading the Mention Me tag shown on refresh or page change.
    if (window.MentionMeFiredTags != undefined && window.MentionMeFiredTags != '') {
      if (window.MentionMeFiredTags[mmImplementation + mmSituation] == true) {
        delete window.MentionMeFiredTags[mmImplementation + mmSituation]
      }
    }

    // URL Components
    const urlComponents = [
      "https://tag.mention-me.com/api/v2/refereefind/",
      mmId
    ];

    // Setup Script
    const queryComponentsConfig = [
      ["situation", mmSituation],
      ["locale", mmLocale],
    ];
    const queryComponents = queryComponentsConfig.map((qc) => qc[0] + "=" + encodeURIComponent(qc[1]));
    const url = urlComponents.join("") + "?" + queryComponents.join("&");
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = url;
    script.defer = true;

    // Boot Script
    document.getElementsByTagName("head")[0].appendChild(script);
  });
})();
